import { FC } from 'react';
import { QcsButton } from './QcsButton';

type QcsButtonProps = React.ComponentProps<typeof QcsButton>;

export const TableRowButton: FC<QcsButtonProps> = ({ onClick, ...rest }) => {
  return <QcsButton {...rest} stopPropagation onClick={onClick} />;
};